import { render } from "./DefiAnalytics.vue?vue&type=template&id=7b2404f2&scoped=true"
import script from "./DefiAnalytics.vue?vue&type=script&lang=js"
export * from "./DefiAnalytics.vue?vue&type=script&lang=js"

import "./DefiAnalytics.vue?vue&type=style&index=0&id=7b2404f2&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2404f2"],['__file',"resources/js/components/DefiAnalytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b2404f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b2404f2', __exports__)) {
    api.reload('7b2404f2', __exports__)
  }
  
  module.hot.accept("./DefiAnalytics.vue?vue&type=template&id=7b2404f2&scoped=true", () => {
    api.rerender('7b2404f2', render)
  })

}


export default __exports__